import { render } from "./User.vue?vue&type=template&id=185785dd"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
script.render = render

export default script